module.exports = __webpack_public_path__ + "static/media/amex.6058d4b9.svg";